import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { PageHeader } from "../../layout/AppLayout";
import { ErpSelect, ErpTable, today } from "../../components/erp";
import { errorText } from "../../api/client";
import { paymentSummaryApi, PaymentSummaryRow } from "./api";

const BILLER_TYPES = [{ value: "0", label: "Supplier" }, { value: "1", label: "Agent" }];

/** Port of v3/Purchase/rm-payment-summary.php + Ajax/AjaxPaymentSummary.php (RmPaymentSummaryReportController). */
export default function PaymentSummary() {
  const qc = useQueryClient();
  const [start, setStart] = useState(today()); const [end, setEnd] = useState(today()); const [billerType, setBillerType] = useState("0");
  const [q, setQ] = useState<{ StartDate: string; EndDate: string; BillerType: string } | null>(null);
  const list = useQuery({ queryKey: ["purchase", "payment-summary", q], enabled: !!q, queryFn: () => paymentSummaryApi.report(q!) });
  const rows = list.data?.Data?.PaymentDateWiseReportData || [];

  const del = async (row: PaymentSummaryRow) => {
    if (!window.confirm(`Delete payment voucher ${row.Voucher}?`)) return;
    await paymentSummaryApi.deletePayment({ PaymentID: row.PaymentID, BillerType: row.BillerType, ...q });
    qc.invalidateQueries({ queryKey: ["purchase", "payment-summary", q] });
  };

  return (
    <>
      <PageHeader title="Payment Summary" location="Purchase" />
      <div className="row rowFilter"><div className="col-md-12"><div className="card"><div className="card-body"><div className="row">
        <div className="col col-md-3 mb-3"><input type="date" className="form-control" max={today()} value={start} onChange={(e) => setStart(e.target.value)} data-testid="ps-start-date" /></div>
        <div className="col col-md-3 mb-3"><input type="date" className="form-control" max={today()} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="ps-end-date" /></div>
        <div className="col col-md-3 mb-3"><ErpSelect id="drpPsBillerType" placeholder="Biller Type" value={billerType} onChange={setBillerType} options={BILLER_TYPES} /></div>
        <div className="col col-md-3 mb-3"><button type="button" className="btn btn-primary" onClick={() => setQ({ StartDate: start, EndDate: end, BillerType: billerType })} data-testid="btn-ps-search">Search</button></div>
      </div></div></div></div></div>
      <div className="card"><div className="card-body">
        <ErpTable<PaymentSummaryRow> rows={rows} loading={list.isLoading} error={list.isError ? errorText(list.error) : list.data?.Error || null} testId="payment-summary-table"
          columns={[
            { key: "SNO", title: "S.No" }, { key: "PayDate", title: "Pay Date" }, { key: "Supplier", title: "Supplier" }, { key: "AgentName", title: "Agent" },
            { key: "Voucher", title: "Voucher" }, { key: "ChequeNo", title: "Cheque No" }, { key: "Amount", title: "Amount", className: "text-end fw-bold" },
            { key: "act", title: "Actions", render: (r) => <>
              <Link to={`/v3/Purchase/rm-payment-voucher?PayDate=${r.PayDate.split("-").reverse().join("-")}&VoucherNo=${r.Voucher}&BillerType=${r.BillerType}&SupplierID=${r.SupplierID}`} className="me-2 text-primary" data-testid={`view-voucher-${r.PaymentID}`}><i className="mdi mdi-eye font-size-18" /></Link>
              <button type="button" className="btn btn-link p-0 text-danger" onClick={() => del(r)} data-testid={`delete-payment-${r.PaymentID}`}><i className="mdi mdi-delete font-size-18" /></button></> },
          ]}
          footer={rows.length > 0 ? <tr><td colSpan={6} className="erp-grand text-end">Total</td><td className="erp-grand text-end" data-testid="ps-total">{list.data?.Data?.Totals.TotalAmount}</td><td /></tr> : undefined}
        />
      </div></div>
    </>
  );
}
